// v0.6.12 A5-27 — the reason for filing without a registration, picked.
//
// One act, two boxes: RegistrationCoverageBanner's popover and the
// FilingStatusDrawer's inline form both post to
// /runs/calc/{id}/coverage/acknowledge. They were two separate free-text
// boxes with two different placeholders; this is the one control both
// render, so the choices offered can never drift apart.
//
// The list is keyed by the gap's reason_code (COVERAGE_ACK_REASONS);
// "Other" opens the textarea. `onChange(preset, note)` hands back both
// pieces of state, the same pair PerRowResolver keeps.
import React from "react";
import { Textarea } from "./ui/textarea";
import { PresetReasonSelect } from "./PresetReasonSelect";
import { coveragePresetsFor } from "../lib/reviewReasonPresets";

export const CoverageAckReason = ({
  gap, preset, note, onChange, presetTestid, noteTestid,
  placeholder = "", rows = 2,
}) => (
  <div className="space-y-2">
    <PresetReasonSelect
      testid={presetTestid}
      presets={coveragePresetsFor(gap?.reason_code)}
      preset={preset}
      onPick={(p, v) => onChange(p, v)}
    />
  </div>
);

export default CoverageAckReason;
